import { Component, OnInit, Input } from '@angular/core';
//import { UserService } from '../../../shared'
//import { Puser, SWF, User } from '../../../shared/models';
import { environment } from '../../../shared/config/app-config';
import { UserService } from '../../../shared';
@Component({
  selector: 'app-defaultcontactus',
  templateUrl: './defaultcontactus.component.html',
  styleUrls: ['./defaultcontactus.component.css']
})
export class DefaultcontactusComponent implements OnInit {
  @Input() contactData: any;
  //CurrentUser: User;
  //contactData:any;
  constructor(private userService: UserService) { }
  public imageURL: string = environment.cloudeImageURL;
  ngOnInit() { 
    this.userService.currentUser.subscribe(
      (userData) => {
        let CurrentUser = userData;
        // ////console.log(this.CurrentUser)
        if (CurrentUser.item) {
          if (CurrentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;

        }
      }
    )
  }
  openMailBox(mailid)
  {
      location.href = "mailto:"+mailid;
  }

}
